// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"4addec0b","40":"de947288","60":"7e5f2e26","121":"2f322d6d","228":"8827c509","272":"f512537c","307":"688a6680","493":"dfc642a9","661":"f256f4a0","769":"ae489f4b","796":"a5360b3b","896":"f57f560a","919":"e4f78312","948":"8ed24e57","950":"77c61cd4"}[chunkId] + ".chunk.js";
};